"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_1 = __importDefault(require("../utils/styled"));
exports.PageArea = styled_1.default("div", { shouldForwardProp: prop => prop !== "fill" })(({ name, fill = false }) => ({
    gridArea: name,
    height: fill ? "100%" : "auto",
}));
exports.default = exports.PageArea;
//# sourceMappingURL=PageArea.js.map